/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

export enum HnaRequestStatus {
  REQUESTED = 'Requested',
  PROCESSING = 'Processing',
  COMPLETE = 'Complete',
  EXPIRED = 'Expired',
}

export enum HnaNetworkApprovalState {
  REQUESTED = 'Requested',
  APPROVED = 'Approved',
  DENIED = 'Denied',
}

export interface HnaNetwork {
  network: string;
  state: HnaNetworkApprovalState;
}

export interface HnaZone {
  country: string;
  networks: HnaNetwork[];
}

export interface HnaRequest {
  id: string;
  missionPlanId?: string;
  requestorName: string;
  requestorOrgName: string;
  antennaType: string;
  missionNumber: string;
  tailNumbers: string[];
  missionStartDate: string;
  missionEndDate: string;
  requestedAt: string;
  apacsId: string;
  additionalInfo?: string;
  hnaZones: HnaZone[];
  status: HnaRequestStatus;
  authorizationStartDate?: string;
  authorizationEndDate?: string;
  notes?: string;
}